import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-accordion-secondary',
  templateUrl: './accordion-secondary.component.html',
  styleUrls: []
})
export class AccordionSecondaryComponent {
  @Input() id = '';
  @Input() text = '';

  isCollapsed = true;

  onCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }
}
